import axios from "axios";
import { aliasPlatform, getToken } from "../../../utils/helper";
import { buildQueryString } from "../../../utils/functions/string";
import { FNB_PLATFORM, RETAIL_PLATFORM } from "../../../utils/constant";

interface IParams {
  platform: string;
  branch_id?: string;
  get_all?: boolean;
}

type ResponseRequset = {
  success: boolean;
  data: any[];
  errrors?: any;
};

export async function getMerchantInfo({ platform }: IParams) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/info`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + getToken(),
  };
  const res = await axios.get(url, {
    headers,
  });
  return res.data;
  // const shortPl = aliasPlatform(platform);
  // const url = `api/v1/${shortPl}/branch/info`;
  // const res = await axios.get(url);
  // res.data.status = 0;
  // return res.data;
}

export async function loadListPriceFormulas({
  platform,
  type,
}: {
  platform: string;
  type: string;
}) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/price-formula/list?type=${type}`;
  const res = await axios.get(url);
  return res.data;
}

export async function updatePriceFormulas({
  platform,
  data,
}: {
  platform: string;
  data: {
    web_order_price_formula_id?: number;
    emenu_price_formula_id?: number;
  };
}) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/price-formula/update`;
  const res = await axios.post(url, data);
  return res.data;
}

export async function loadOverviewFnb({ platform }: IParams) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/overview`;
  const res = await axios.get(url);
  return res.data;
}

export async function resyncFnb({ platform }: IParams) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/re-sync`;
  const res = await axios.post(url);
  return res.data;
}

export async function loadListTheme({ platform }: IParams) {
  const shortPl = aliasPlatform(platform);
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const url = `api/v2/merchants/${shortPl}/onboarding/theme/list`;
  const res = await axios.get(url, {
    headers,
  });
  return res.data;
}

export async function changeStatusPartnerType({
  platform,
  data,
}: {
  platform: string;
  data: {
    partnerType: string;
    status: boolean;
  };
}) {
  const shortPl = aliasPlatform(platform);
  const linkPath = data.status ? "active" : "deactive";
  const url = `api/v2/merchants/${shortPl}/${linkPath}`;
  const res = await axios.post(url, data);
  return res.data;
}

export async function loadBranchInfoOnboard({
  platform,
}: {
  platform: string;
}) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/info`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const res = await axios.get(url, {
    headers,
  });
  return res.data;
}

export async function getSyncState(platform = "retail") {
  const shortPl = aliasPlatform(platform);
  let url = `api/v2/merchants/${shortPl}/onboarding/branch/sync-state`;
  if (platform === FNB_PLATFORM) {
    url = `/api/v2/merchants/${platform}/onboarding/first-sync-state`;
  }
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " + getToken(),
  };
  const res = await axios.get(url, {
    headers,
  });
  return res.data;
}

export async function activeBranch(platform: string) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/active`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const res = await axios.post(
    url,
    {},
    {
      headers,
    }
  );
  return res.data;
}

export async function updateOnboardingStep(
  platform: string,
  is_onboarding: boolean
) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/update-is-onboarding`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const res = await axios.post(
    url,
    { is_onboarding },
    {
      headers,
    }
  );
  return res.data;
}

export async function updateCurrentOnboardingStep(
  platform: string,
  step_onboarding: number
) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/update-step-onboarding`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const res = await axios.post(
    url,
    { step_onboarding },
    {
      headers,
    }
  );
  return res.data;
}

export async function updateStepOnboard(
  platform: string,
  step_onboarding: number
) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/update-step-onboarding`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const res = await axios.post(
    url,
    { step_onboarding },
    {
      headers,
    }
  );
  return res.data;
}

export async function updateBranchInfo(platform: string, params: any) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/update`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const res = await axios.post(url, params, {
    headers,
  });
  return res.data;
}

export async function updateFinishStep(
  platform: string,
  params: { branchName: string; themeId: string; themeIdWebOrder?: string }
) {
  const shortPl = aliasPlatform(platform);
  const url = `api/v2/merchants/${shortPl}/onboarding/branch/finish-onboarding`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " +
      (localStorage.getItem("mykiot_auth_code") ||
        localStorage.getItem("mykiot_access_token")),
  };
  const res = await axios.post(url, params, {
    headers,
  });
  return res.data;
}

export async function getRefreshToken() {
  const url = `api/v2/auth/admin/refresh-token`;
  const headers = {
    "Content-Type": "application/json",
    Authorization:
      "Bearer " + getToken(),
  };
  const res = await axios.post(
    url,
    {},
    {
      headers,
    }
  );
  return res.data;
}

export async function getMerchantPriceBookRetail({
  platform = "retail",
  branch_id = "",
  get_all = false,
}: IParams) {
  const shortPl = aliasPlatform(platform);
  const payload = {
    branch_id,
    is_get_all: get_all,
  };
  const res = await axios.get(
    `api/v1/${shortPl}/merchant/price-book/info?${buildQueryString(payload)}`
  );
  return res.data.response;
}

export async function getMerchantCurrentPriceBookRetail({
  platform = "retail",
}: IParams) {
  const shortPl = aliasPlatform(platform);
  const res = await axios.get(
    `api/v1/${shortPl}/merchant/get-current-price-book/info`
  );
  return res.data.response;
}

interface IBranchInfoDirect {
  platform: string;
  merchantId: number;
  merchantCode: string;
  branchId: number;
}

export async function getBranchInfoDirect({
  platform,
  merchantId,
  merchantCode,
  branchId,
}: IBranchInfoDirect) {
  const response = await axios.get(`/api/v1/retail/branch/info-direct`, {
    params: {
      platform,
      merchantId,
      merchantCode,
      branchId,
    },
  });

  return response;
}

export async function fetchFeaturesList() {
  const response = await axios.get(`/api/v2/merchants/features`);
  if (response.status === 200) {
    return {
      success: true,
      data: response.data,
    };
  }
  return {
    success: false,
    data: [],
  };
}

export async function getSettingFeatureByType(type: string) {
  const response = await axios.get(`/api/v2/merchants/features/${type}`);
  if (response.status === 200) {
    return {
      success: true,
      data: response.data,
    };
  }
  return {
    success: false,
    data: [],
  };
}

export async function updateSettingFeatureByType(type: string, payload?: any) {
  const response = await axios.put(
    `/api/v2/merchants/features/${type}`,
    payload
  );
  if (response.status === 200) {
    return {
      success: true,
      data: { ...response.data.settings },
    };
  }

  return {
    success: false,
    data: {},
  };
}

export async function getSettingsActiveFeatures(platform: string) {
  const response = await axios.get(
    `/api/v2/merchants/${platform}/active-feature`
  );

  if (response.status === 200) {
    return {
      success: true,
      data: { ...response.data.settings },
    };
  }

  return {
    success: false,
    data: {},
  };
}

export async function getInstructionFeature(
  categoryCode: string,
  params: {
    page: number;
    limit: number;
  }
): Promise<
  ResponseRequset & {
    total_item: number;
    total_page: number;
  }
> {
  const url = `/api/v2/merchants/video-instruction/category/${categoryCode}?${buildQueryString(
    params
  )}`;
  const response = await axios.get(url);
  if (response.status === 200) {
    return {
      success: true,
      data: response.data.data,
      total_item: response.data.total_item,
      total_page: response.data.total_page,
    };
  }

  return {
    success: false,
    data: [],
    total_item: 0,
    total_page: 0,
  };
}

export const updateInstructionFeature = async ({
  platform,
  type,
}: {
  platform: string;
  type: string;
}) => {
  const response = await axios.put(
    `/api/v2/merchants/${platform}/active-feature?type=${type}`
  );

  if (response.status === 200) {
    return {
      success: true,
      data: { ...response.data.settings },
    };
  }

  return {
    success: false,
    data: {},
  };
};

export const getBranchFromMerchant = async (
  platform: string
): Promise<{
  success: boolean;
  data: any[];
}> => {
  const url = `api/v2/merchants/branch/retail/get-by-merchant`;
  const response = await axios.get(url);
  if (response.status === 200) {
    return {
      success: true,
      data: [...response.data.data],
    };
  }

  return {
    success: false,
    data: [],
  };
};

export const updateStatusMinistryOfIndustryAndTrade = async (
  urlGov: string,
  is_active: boolean
): Promise<{
  success: boolean;
}> => {
  const url = `api/v2/merchants/branch/update-ministry_of_industry_and_trade`;
  const response = await axios.post(url, {
    url: urlGov,
    is_active,
  });
  if (response?.data?.status === 200) {
    return {
      success: true,
    };
  }

  return {
    success: false,
  };
};

export const upgradeThemeToNewVersion = async (platform: string) => {
  const url = `api/v2/merchants/${platform}/upgrade-to-v2`;
  try {
    const response = await axios.post(url);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      data: {},
      error: error.message,
    };
  }
};

export const checkTypeUserRetail = async ({retailerId} : {retailerId: number}) => {
  const res = await axios.get(`https://core-api.mykiot.vn/api/v1/check-store-exist?store_id=${retailerId}`);
  return res && res.data;
}

export const checkModalMerchantSurveyCustomer = async (type: 'onboarding' | 'publish' | 'stop_publish' | 'page_builder') => {
  const res = await axios.get(`/api/v2/merchants/popup?type=${type}`);
  return res && res.data && res.data?.data ? res.data.data?.is_show || false : false;
}

export const saveModalMerchantSurveyCustomer = async (data: { type: string, content: string[] }) => {
  const res = await axios.post(`/api/v2/merchants/popup/save`, data);
  return res && res.data;
}

export const getModalSurveyWebsiteUsingEasy = async (callbackFunction: (res: boolean) => void) => {
  const res = await checkModalMerchantSurveyCustomer('page_builder');
  callbackFunction(res);
}
